import { render, staticRenderFns } from "./QuotedMessage.vue?vue&type=template&id=083cccfb&scoped=true"
import script from "./QuotedMessage.vue?vue&type=script&lang=js"
export * from "./QuotedMessage.vue?vue&type=script&lang=js"
import style0 from "./QuotedMessage.vue?vue&type=style&index=0&id=083cccfb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083cccfb",
  null
  
)

export default component.exports